import { useQuery } from '@tanstack/react-query';

import { type VoucherAutoAssignmentRuleFetchResult, getVoucherAutoAssignmentRule } from '~/services/PromoService';

import ApiError from '~/types/ApiError';

import { voucherAutoAssignmentRuleQueryKeys } from './voucherAutoAssignmentRuleQueryKeys';

type Params = {
  ruleId?: string;
};

export function useFindVoucherAutoAssignmentRule({ ruleId }: Params) {
  return useQuery<VoucherAutoAssignmentRuleFetchResult | null>({
    queryKey: voucherAutoAssignmentRuleQueryKeys.detail(ruleId ?? ''),
    queryFn: async ({ signal }) => {
      if (!ruleId) {
        return null;
      }
      try {
        const res = await getVoucherAutoAssignmentRule(ruleId, { signal });
        return res.result;
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          return null;
        }
        throw err;
      }
    },
    enabled: Boolean(ruleId),
  });
}
